import React, { useState, useEffect } from "react";
import style from "./authlayout.module.scss";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  const carouselData = [
    {
      id: 1,
      src: "/task_management.svg",
      header: "Welcome Back to Your Productivity Hub!",
      text: "TaskFlow – Stay organized, prioritize tasks, and boost productivity effortlessly!",
    },
    {
      id: 2,
      src: "/task_management.svg",
      header: "Manage your projects and clients easily",
      text: "TaskFlow – Stay organized, prioritize tasks, and boost productivity effortlessly!",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 790);

  // Auto switch slides every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [carouselData.length]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 790);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={style.auth_screen}>
      <div className={style.left_child}>
        <div className={style.header}>
          <img src="/logo.svg" alt="brand_logo" />
          <h1 className={style.text}>Task M.</h1>
        </div>
        <Outlet />
      </div>

      {!isMobile && (
        <div className={style.right_child}>
          {/* Carousel Content */}
          <div className={style.carousel_content}>
            <img src={carouselData[activeIndex].src} alt="Task Management" />

            <div className={style.carousel_header}>
              {carouselData[activeIndex].header}
            </div>

            <div className={style.carousel_text}>
              {carouselData[activeIndex].text}
            </div>
          </div>

          {/* Carousel Navigation Dots */}
          <div className="d-flex gap-2">
            {carouselData.map((_, index) => (
              <div
                key={index}
                className={`${style.carousel_line} ${
                  index === activeIndex ? style.active : ""
                }`}
                onClick={() => setActiveIndex(index)}
              ></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthLayout;